import React from "react";
import "./styles.css";

function Values(props){
    return(
        <div className="slide_size">
            <img src={props.img} alt="" />
            <h1>{props.title}</h1>
            <p>{props.para}</p>
        </div>
    );
}

export default Values;